import { render, staticRenderFns } from "./AddExternalTicketingUser.vue?vue&type=template&id=c0f51e90&scoped=true"
import script from "./AddExternalTicketingUser.vue?vue&type=script&lang=js"
export * from "./AddExternalTicketingUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0f51e90",
  null
  
)

export default component.exports